/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * Used by ItemGrid and ItemCarousel.
 */
import { getSnapshot } from 'mobx-state-tree';
import { uniqBy } from 'lodash-es';
const getAsset = async (store, key, size = 'thumb400w') => {
    if (!key) {
        return null;
    }
    const asset = await store.load('asset', key);
    await store.load('repository', asset?.repository?.key);
    await asset.getSignedUrl(size);
    return asset;
};
export const getInstructors = async (store, instructors) => {
    const keys = instructors?.map((instructor) => ({ modelName: 'instructor', key: instructor.key }));
    await store.batchLoad(keys);
    const assets = await store.batchLoad(instructors.map((instructor) => ({ modelName: 'asset', key: instructor.profileImage?.key })));
    return instructors;
};
/**
 * Helper to load course related assets
 */
export const getCourseData = async (store, key) => {
    console.log('loading course', key);
    const course = await store.load('course', key);
    const assetWait = await getAsset(store, course.courseImage?.key);
    const instructorsWait = getInstructors(store, course.instructors);
    await Promise.allSettled([assetWait, instructorsWait]);
    console.log('loaded course', course.key);
    return course.id;
};
/**
 * Helper to load course related assets
 */
export const getDocumentData = async (store, key) => {
    console.log('loading document', key);
    const document = await store.load('document', key);
    const assetWait = await getAsset(store, document.image?.key);
    const instructorsWait = getInstructors(store, document.instructors);
    await Promise.allSettled([assetWait, instructorsWait]);
    console.log('loaded document', document.key);
    return document.id;
};
/**
 * Helper to load course related assets
 */
export const getProgramData = async (store, key) => {
    console.log('loading program', key);
    const program = await store.load('program', key);
    const asset = getAsset(store, program.programImage?.key);
    const instructors = getInstructors(store, program.instructors);
    await Promise.allSettled([asset, instructors]);
    console.log('loaded program', program.key);
    return program.id;
};
/**
 * Helper to load course related assets
 */
export const getMeetingData = async (store, key) => {
    console.log('loading meeting', key);
    const meeting = await store.load('meeting', key);
    const assetWait = await getAsset(store, meeting.image?.key);
    const instructorsWait = getInstructors(store, meeting.instructors);
    await Promise.allSettled([assetWait, instructorsWait]);
    console.log('loaded meeting', meeting);
    return meeting.id;
};
/**
 * Helper to load microcast related assets
 */
export const getMicrocastData = async (store, microcast) => {
    console.log('loading microcast', microcast.key);
    await store.load('microcast', microcast.key);
    const asset = (microcast?.microcastImage)
        ? getAsset(store, microcast.microcastImage?.key)
        : getAsset(store, microcast.microcastAsset.key, 'videoThumb');
    const instructors = getInstructors(store, microcast.instructors);
    await Promise.allSettled([asset, instructors]);
    console.log('loaded microcast', microcast.key);
    return microcast.id;
};
const getData = async ({ categoryId, items, context, }, store) => {
    try {
        console.log('Adding category to preload', {
            categoryId,
            items,
        });
        if (!categoryId && !items) {
            console.log('No category or items to load for ItemGrid');
            return categoryId;
        }
        let itemsToLoad = items || [];
        if (categoryId) {
            const category = context.portal.getCategory(categoryId);
            if (!category) {
                console.log('Category not found', categoryId);
                console.log('portal', getSnapshot(context.portal));
                return categoryId;
            }
            itemsToLoad = itemsToLoad.concat(category.items ?? []);
        }
        // now load all the item in that category
        // eslint-disable-next-line arrow-body-style
        // const promises = itemsToLoad.map((item:any) => {
        //   if (!item?.id) {
        //     console.log('Skipping null item', item);
        //     return Promise.resolve('no item');
        //   }
        //   if (item.type === 'course') {
        //     return getCourseData(store, item.course.key);
        //   }
        //   if (item.type === 'microcast') {
        //     return getMicrocastData(store, item.microcast.key);
        //   }
        //   if (item.type === 'program') {
        //     return getProgramData(store, item.program.key);
        //   }
        //   if (item.type && item[item.type]?.id) {
        //     console.log('loading item', item.type, item[item.type]?.id);
        //     return store.load(item.type, item[item.type]?.id);
        //   }
        //   console.log('missing data', { itemType: item.type, itemTypeId: item[item.type]?.id });
        //   return Promise.resolve('ok');
        // });
        // return Promise.allSettled(promises);
        const loadList = itemsToLoad.map((item) => ({ modelName: item.type, key: item[item.type]?.key }));
        const loadedItems = await store.batchLoad(loadList);
        // these are the thumbnails
        const assetList = loadedItems.map((item) => {
            if (item.isCourse()) {
                return { modelName: 'asset', key: item.courseImage?.key };
            }
            if (item.isProgram()) {
                return { modelName: 'asset', key: item.programImage?.key };
            }
            if (item.isMicrocast()) {
                return { modelName: 'asset', key: item.microcastImage?.key };
            }
            return null;
        });
        const instructorList = uniqBy(loadedItems.map((item) => (item.instructors))
            .filter(Boolean)
            .flat()
            .map((instructor) => ({ modelName: 'instructor', key: instructor.key })), 'id');
        // console.log('Asset list', assetList);
        // console.log('Instructor list', instructorList);
        const [assets, instructorsLoaded] = await Promise.all([
            store.batchLoad(assetList),
            store.batchLoad(instructorList),
        ]);
        // console.log('getData', { assets, instructorsLoaded });
        // load the repositories
        const repositoryList = uniqBy(assets.map((asset) => ({ modelName: 'repository', key: asset.repository?.key })), 'id');
        // console.log('Loading repositories', repositoryList);
        const repos = await store.batchLoad(repositoryList);
        const signingPromises = assets.map((image) => (image.getSignedUrl('thumb400w')));
        await Promise.allSettled(signingPromises);
        return 'ok';
    }
    catch (e) {
        console.error('Error on getData', e);
        return 'error';
    }
};
export default getData;
//# sourceMappingURL=getData.js.map